import { apis, inWindow } from '@/config';
import { isSupportNativeProxy } from './util';
class AbsWrapper {
    constructor(name) {
        this.name = name;
    }
    init() {
        return this.name;
    }
}
if (!isSupportNativeProxy) {
    const noop = function () { };
    const fns = process.env.BUILD_ISWEB
        ? [
            'get',
            'delete',
            'head',
            'options',
            'post',
            'put',
            'patch',
            'buildUrl',
            'addConfig',
            'setDisableCache',
            'buildRequestKey',
            'getUrlPath',
            'cleanCacheEntry',
            'setLogoutStatus',
            'getDeviceInfo',
            'getLogoutPage',
            'addCommonHeader',
            'updateDeviceInfo',
            'triggerCurrentUserLogout',
            'del',
            'clear',
            'getSync',
            'putSync',
            'getSeqHelper',
            'setLastAccount',
            'getCurrentUser',
            'doGetCookies',
            'setUserProp',
            'setCurrentNode',
            'getCurrentNode',
            'getLock',
            'getUUID',
            'loadUser',
            'isLogout',
            'getKey',
            'addWatchedKey',
            'contextPath',
            'isMsiBuild',
            'isFirstInit',
            'handleAccountAndDomain',
            'getCurrentUserMailMode',
            'getIsCorpMailMode',
            'openNewWindow',
            'webDownloadLink',
            'intervalEvent',
            'cancelEvent',
            'encryptMsg',
            'decryptMsg',
            'md5',
            'sha1',
            'generateKey',
            'isElectron',
            'isMainWindow',
            'isInMobile',
            'isMainPage',
            'getUrl',
            'isInWebWorker',
            'isNetworkAvailable',
            'getNetworkFailIndex',
            'showSysNotification',
            'isSysNotificationAvailable',
            'requestSysNotificationPerm',
            'updateAppNotification',
            'watchLogin',
            'watchPreLogin',
            'closeWindow',
            'closeSubWindow',
            'getCurrentWinInfo',
            'getCurrentModule',
            'doGetCookies',
            'clearUserAuthCookie',
            'getStartTimeSpan',
            'createWindow',
            'createWindowWithInitData',
            'handleJumpUrl',
            'decryptByKey',
            'encryptByKey',
            'buildJumpUrl',
            'getBrowserInfo',
            'hideWindow',
            'getNativeClipBoard',
            'rsaEncrypt',
            'getAutoLaunch',
            'setAutoLaunch',
            'getAllWindow',
            'showMainWindow',
            'getLocalLoginToken',
            'addWindowHooks',
            'addWindowHookConf',
            'navigateToSchedule',
            'switchLoading',
            'switchAppLoading',
            'inWebMail',
            'invalidate',
            'showWin',
            'hideWin',
            'prepareWindow',
            'isStartWindow',
            'isTransferringData',
            'isBkLoginInit',
            'isBkStableWindow',
            'getProxyOn',
            'setProxyOn',
            'getIsDomesticHostType',
            'getCurrentHostType',
            'setCurrentHostType',
            'reLaunchApp',
            'getIsAddAccountPage',
            'jumpToWebHostLogin',
            'setCurrentSessionName',
            'getCurrentSessionName',
            'getFolderSize',
            'inEdm',
            'getIsAddSubAccountPage',
            'getIsSubAccountPage',
            'getIsSubAccountInitPage',
            'getIsAddPersonalSubAccountPage',
            'getUrlSearchValue',
            'getMainAccount',
            'getCurrentSubAccount',
            'getCurrentAgentAccount',
            'getSessionNameOfSubAccount',
            'getIsLowMemoryMode',
            'setIsLowMemoryMode',
            'getIsLowMemoryModeSync',
            'inElectronBuild',
            'inWebBuild',
            'inLingXiBuild',
            'registerSysEventObserver',
            'unregisterSysEventObserver',
            'sendSysEvent',
            'sendSimpleSysEvent',
            'setupWebWorker',
            'terminateWebWorker',
            'postMessage',
            'confirmEvent',
            'dumpMessageFromQueue',
            'getObserverByName',
            'getFileInfoByFileName',
            'upload',
            'downloadLocalFile',
            'saveDownload',
            'download',
            'clipboardWriteImage',
            'saveZip',
            'saveAll',
            'getFsDownloadStatus',
            'abortFsDownload',
            'testLocalFile',
            'openFile',
            'saveAs',
            'judgeFileType',
            'storeFileInfo',
            'registerTmpFile',
            'saveTmpFile',
            'getAttachmentZipPath',
            'getFileInfo',
            'getFileKey',
            'delFileInfo',
            'delAttachmentZipPath',
            'show',
            'openDir',
            'selectFile',
            'moveFilePath',
            'uploadFile',
            'uploadPieceByPiece',
            'initDb',
            'getTableCount',
            'getById',
            'getByIds',
            'getByIndexIds',
            'getByEqCondition',
            'putAll',
            'bulkPut',
            'close',
            'closeSpecific',
            'deleteById',
            'getByRangeCondition',
            'addFilterRegistry',
            'deleteByByRangeCondition',
            'deleteDB',
            'removeAccountAction',
            'track',
            'time',
            'initLimit',
            'doGetAccountInfo',
            'isInited',
            'setCurrentAccount',
            'newUsersIntoEmailList',
            'doGetOrgList',
            'getAuthConfig',
            'triggerNotificationInfoChange',
            'getMailMergeSettings',
            'getABSwitchSync',
            'saveAuthConfigFromNet',
            'doSaveCurrentAccount',
            'doGetContactByItem',
            'timeEnd',
            'getSubAccounts',
            'syncAllMails',
            'mailOperationEmailListChange',
            'point',
            'initModel',
            'getIsSharedAccountAsync',
            'doListMailBoxEntities',
            'isWebWmEntry',
            'getActiveUserTrackParams',
            'doListMailBox',
            'doGetDefaultSign',
        ]
        : [];
    fns.forEach(fnName => {
        AbsWrapper.prototype[fnName] = noop;
    });
}
class ProxyFactory {
    constructor(dfn) {
        this.defaultImplName = dfn;
    }
    getImpl() {
        const api1 = api.requireLogicalApi(this.defaultImplName);
        if (this.impl && api1 === this.impl) {
            console.error('can not get impl', this.defaultImplName);
            return api.requireLogicalApi(apis.emptyApiImpl);
        }
        this.impl = api1;
        return api1;
    }
    getProxyInstance() {
        const that = this;
        return new Proxy(new AbsWrapper(this.defaultImplName), {
            get(_, p) {
                if (p === '__isProxy')
                    return 'yes';
                if (p === 'name')
                    return that.defaultImplName + '-proxy';
                let { impl } = that;
                if (!impl || impl.__isProxy === 'yes') {
                    impl = that.getImpl();
                }
                if (impl && impl.__isProxy !== 'yes' && impl[p]) {
                    let implElement = impl[p];
                    if (typeof implElement === 'function') {
                        implElement = implElement.bind(that.impl);
                    }
                    return implElement;
                }
                return impl[p];
            },
        });
    }
}
class ApiFactory {
    constructor() {
        this.defaultDataTransApi = new ProxyFactory(apis.defaultApiImpl).getProxyInstance();
        this.defaultDataStoreApi = new ProxyFactory(apis.defaultDataStoreApiImpl).getProxyInstance();
        this.defaultSystemApi = new ProxyFactory(apis.defaultSystemApiImpl).getProxyInstance();
        this.defaultEventApi = new ProxyFactory(apis.defaultEventApi).getProxyInstance();
        this.defaultFileApi = new ProxyFactory(apis.defaultFileApi).getProxyInstance();
        this.defaultDBApi = new ProxyFactory(apis.dbInterfaceApiImpl).getProxyInstance();
    }
    requireDataTransApi(name) {
        return this[name];
    }
    getDataTransApi() {
        return this.defaultDataTransApi;
    }
    requireDataStoreApi(name) {
        return this[name];
    }
    getEventApi() {
        return this.defaultEventApi;
    }
    requireEventApi(name) {
        return this[name];
    }
    getDataStoreApi() {
        return this.defaultDataStoreApi;
    }
    requireSystemApi(name) {
        return this[name];
    }
    getSystemApi() {
        return this.defaultSystemApi;
    }
    registerFileApi(impl) {
        this[impl.name] = impl;
    }
    getFileApi() {
        return this.defaultFileApi;
    }
    getNewDBApi() {
        return this.defaultDBApi;
    }
    requireNewDBApi(name) {
        return this[name];
    }
    registerDataTransApi(impl) {
        if (!impl) {
            throw new Error('wrong http api');
        }
        this[impl.name] = impl;
    }
    registerEventApi(impl) {
        if (!impl) {
            throw new Error('wrong event api');
        }
        this[impl.name] = impl;
    }
    registerSystemApi(impl) {
        if (!impl) {
            throw new Error('wrong system api');
        }
        this[impl.name] = impl;
    }
    registerDataStoreApi(impl) {
        if (!impl) {
            throw new Error('wrong data store api');
        }
        console.log('[api]register.storeApi.init');
        this[impl.name] = impl;
    }
    registerDataNewDbApi(impl) {
        if (!impl) {
            throw new Error('wrong newdb api');
        }
        this[impl.name] = impl;
    }
    registerDataDbApi(impl) {
        if (!impl) {
            throw new Error('wrong db api');
        }
        this[impl.name] = impl;
    }
    requireDataDbApi(name) {
        return this[name];
    }
    registerLogicalApi(impl) {
        if (!impl) {
            throw new Error('wrong logical api');
        }
        this[impl.name] = impl;
    }
    requireLogicalApi(name) {
        const newVar = this[name];
        if (newVar) {
            return newVar;
        }
        const newName = 'proxy_' + name;
        const proxyApi = this[newName];
        if (proxyApi) {
            return proxyApi;
        }
        console.log('require api of ', name);
        const proxyFactory = new ProxyFactory(name);
        const proxyInstance = proxyFactory.getProxyInstance();
        this[newName] = proxyInstance;
        return proxyInstance;
    }
}
const apiIns = new ApiFactory();
if (inWindow()) {
    window.apiResposity = apiIns;
}
else {
}
export const api = apiIns;
